import React, { Component } from "react";
import { withTranslation } from "react-i18next";
import { getCurrentGenerationByMarketDate } from "../../../common/services/marketdata/aesoService";
import Input from "../../../common/components/form/input";
import Select from "../../../common/components/form/select";
import SearchBox from "../../../common/components/search/searchBox";
import Loading from "../../../common/components/loading/loading";
import GenerationByFuelTypeGraph from "../generationByFuelTypeGraph";

//import Loading from "../../common/components/loading/loading";

class GenerationDetails extends Component {
  state = {
    effectiveDate: "",
    maxDate: "",
    minDate: "2024-01-01", //Stub
    generationData: [],
    isLoading: true,
    searchQuery: "",
    selectedFuelType: "All",
    fuelTypes: [],
  };

  async componentDidMount() {
    const { marketDate } = this.props;

    const currentDate = new Date();
    currentDate.setDate(currentDate.getDate() - 1);

    const minDate = new Date(currentDate);
    minDate.setDate(minDate.getDate() - 30);
    const minDateText = new Date(minDate).toLocaleDateString("fr-CA");

    this.setState({
      maxDate: currentDate.toLocaleDateString("fr-CA"),
      minDate: minDateText,
    });

    await this.loadData(marketDate);
  }

  async loadData(effectiveDate) {
    this.setState({ effectiveDate: effectiveDate });

    const generationData = await getCurrentGenerationByMarketDate(
      effectiveDate
    );

    // Extract unique fuel types from the data
    const uniqueFuelTypes = [
      ...new Set(
        generationData.map((item) =>
          item.fuel_type === "GAS"
            ? `GAS_${item.sub_fuel_type}`
            : item.fuel_type
        )
      ),
    ].sort();

    // Create fuel type options including "All"
    const fuelTypes = [
      { fuelType: "All" },
      ...uniqueFuelTypes.map((type) => ({ fuelType: type })),
    ];

    this.setState({
      isLoading: false,
      generationData: generationData,
      fuelTypes: fuelTypes,
    });
  }

  handleDateChange = (date) => {
    this.setState({
      effectiveDate: date,
      isLoading: true,
    });

    (async () => {
      await this.loadData(date);
    })();
  };

  handleSearch = (query) => {
    this.setState({ searchQuery: query });
  };

  handleFuelTypeChange = (fuelType) => {
    this.setState({ selectedFuelType: fuelType });
  };

  groupDataByAsset = (data) => {
    const groupedData = {};
    data.forEach((item) => {
      if (!groupedData[item.asset]) {
        groupedData[item.asset] = [];
      }
      groupedData[item.asset].push(item);
    });
    return groupedData;
  };

  getFilteredData = () => {
    const { generationData, searchQuery, selectedFuelType } = this.state;

    let filtered = generationData;

    // Filter by fuel type if not "All"
    if (selectedFuelType !== "All") {
      filtered = filtered.filter((item) => {
        const itemFuelType =
          item.fuel_type === "GAS"
            ? `GAS_${item.sub_fuel_type}`
            : item.fuel_type;
        return itemFuelType === selectedFuelType;
      });
    }

    // Filter by asset search query
    if (searchQuery) {
      filtered = filtered.filter((item) =>
        item.asset.toLowerCase().includes(searchQuery.toLowerCase())
      );
    }

    return filtered;
  };

  render() {
    const {
      effectiveDate,
      maxDate,
      minDate,
      isLoading,
      searchQuery,
      selectedFuelType,
      fuelTypes,
    } = this.state;

    const { t } = this.props;
    const filteredData = this.getFilteredData();
    const groupedByAsset = this.groupDataByAsset(filteredData);

    return (
      <div className="container-fluid print" style={{ height: "100%" }}>
        <div className="row no-print" style={{ height: "7%" }}>
          <div className="col-md-3">
            <Input
              type="date"
              min={minDate}
              max={maxDate}
              onKeyDown={(e) => e.preventDefault()}
              onChange={(e) => this.handleDateChange(e.currentTarget.value)}
              value={effectiveDate}
              label={t("MarketDate")}
            />
          </div>
          <div className="col-md-3">
            <div className="form-group">
              <label>{t("Asset")}</label>
              <SearchBox
                value={searchQuery}
                onChange={this.handleSearch}
                placeholder={t("SearchAssets")}
              />
            </div>
          </div>
          <div className="col-md-3">
            <Select
              idField="fuelType"
              optionField="fuelType"
              name="fuelType"
              value={selectedFuelType}
              label={t("FuelType")}
              options={fuelTypes}
              onChange={(e) => this.handleFuelTypeChange(e.currentTarget.value)}
            />
          </div>
        </div>
        {isLoading ? (
          <Loading />
        ) : (
          <div className="row no-print" style={{ height: "93%" }}>
            {Object.entries(groupedByAsset).map(([asset, data]) => (
              <div key={asset} className="col-md-3 mb-4">
                <div className="card h-100">
                  <div className="card-header">
                    <h5 className="card-title mb-0">{asset}</h5>
                  </div>
                  <div className="card-body" style={{ height: "300px" }}>
                    <GenerationByFuelTypeGraph
                      data={data}
                      metricField="net_generation"
                      title={`Generation by Fuel Type - ${asset}`}
                      isLoading={isLoading}
                    />
                  </div>
                </div>
              </div>
            ))}
          </div>
        )}
      </div>
    );
  }
}

export default withTranslation(["marketdata"])(GenerationDetails);
